import { ZDate } from '../../../shared/zDate';
export class MFields{
  name?:string;
  lang?:Array<any>;
  vRequired?:boolean;
  readOnly?:boolean;
  template?:string;
  icon?:string;
  fxFlexVal?:string;
  fxFlexCardVal?:string;
  type?:string;
  list?:boolean;
  select?:{
    name?:string;
    static?:boolean;
    dynamic?:boolean;
    table?:string;
    filterV?:string;
    disableCreate?:boolean;
    createDefault?:string;
  };
  fields?:Array<MFields>;
  regex?:string;
  preCode?:string;
  postCode?:string;
}
export class MTable{
  name?:string;
  fields?:Array<MFields>;
  lang?:Array<any>;
  dynamic?:any;
  customControllerD?:string;
  customController?:string;
  customModelD?:string;
  customModel?:string;
}
export class MDB{
  name?:string;
  tables?:Array<MTable>;
}
export class Project {
  _id?: number;
  name?: string;
  db?:MDB;
  insertDoc?:any;
  insertTable?:any;
  module?:any;
  setting?:any;
  workflow?:any;
  createdBy?: {
    _id:number,
    name?:string
  };
  createdDate?:ZDate;
  createdDateX?:ZDate;
  updatedBy?: {
    _id:number,
    name?:string
  };
  updatedDate?:ZDate;
  updatedDateX?:ZDate;
  deleted?: number;
  deletedBy?: {
    _id:number,
    name?:string
  };
  deletedDate?:ZDate;
  deletedDateX?:ZDate;
}



// WEBPACK FOOTER //
// ./src/app/module/project/shared/project.ts